export const HeroSectionData = [
    {
        id: "city_walking_tour",
        title: "City Walking Tour"
    },
    {
        id: "evening_walking_tour",
        title: "Evening Walking Tour"
    },
    {
        id: "half_day_tour",
        title: "Half Day Tour"
    },
    {
        id: "camel_safari_jeep_safari_and_quad_biking",
        title: "Camel Safari Jeep Safari and Quad Biking"
    },

]